import React, { useEffect, useState, useContext } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import StackCell, { CellSizeContainer } from '../../../atoms/Cell/StackCell';

type CollectGridHeaderIoTProps = {
  //isDispPLC: boolean;
};

const useStyles = makeStyles(
  createStyles({
    tableHeader: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
      padding: '1px',
      minWidth: '80px',
      zIndex: 10,
    },
    fixHeader: {
      color: 'white',
      borderWidth: '0px',
      backgroundColor: 'gray',
      outlineWidth: '1px',
      outlineColor: '#dcdcdc',
      outlineStyle: 'solid',
      padding: 0,
      margin: 0,
      textAlign: 'center',
      position: 'sticky',
      zIndex: 20,
      minWidth: '80px',
      borderCollapse: `collapse`,
    },
  })
);

const CollectGridHeaderIoT: React.FC<CollectGridHeaderIoTProps> = (props: CollectGridHeaderIoTProps) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const cnt = new CellSizeContainer();

  const fixNo = (
    <StackCell className={classes.fixHeader} container={cnt} width={50} top={0}>
      No
    </StackCell>
  );
  const fix0 = (
    <StackCell className={classes.fixHeader} container={cnt} width={40} top={0}>
      {t('CollectGridHeader.実行', '実行')}
    </StackCell>
  );
  const fix1 = null;
  const fix2 = null;
  const fix3 = (
    <StackCell className={classes.fixHeader} container={cnt} width={110} top={0}>
      {t('CollectGridHeader.項目名称', '項目名称')}
    </StackCell>
  );
  const fix4 = (
    <StackCell className={classes.fixHeader} container={cnt} width={40} top={0}>
      {t('CollectGridHeader.CH', 'CH')}
    </StackCell>
  );
  const fix5 = (
    <StackCell className={classes.fixHeader} container={cnt} width={120} top={0}>
      {t('CollectGridHeader.信号種別', '信号種別')}
    </StackCell>
  );
  const fix6 = (
    <StackCell className={classes.fixHeader} container={cnt} width={90} top={0}>
      {t('CollectGridHeader.機器番号', '機器番号')}
    </StackCell>
  );
  const fix7 = (
    <StackCell className={classes.fixHeader} container={cnt} width={180} top={0}>
      {t('CollectGridHeader.機器名称', '機器名称')}
    </StackCell>
  );

  const fix8 = (
    <StackCell className={classes.fixHeader} container={cnt} width={160} top={0}>
      {t('CollectGridHeader.ユニット', 'ユニット')}
      <br />
      {t('CollectGridHeader.形式', '形式')}
    </StackCell>
  );

  const colDig = (
    <TableCell className={classes.tableHeader}>
      <Table>
        <TableRow>
          <TableCell colSpan={2} className={classes.tableHeader} width={'140px'}>
            {t('CollectGridHeader.デジタル値', 'デジタル値')}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableHeader}>{t('CollectGridHeader.上限値', '上限値')}</TableCell>
          <TableCell className={classes.tableHeader}>{t('CollectGridHeader.下限値', '下限値')}</TableCell>
        </TableRow>
      </Table>
    </TableCell>
  );
  const colEng = (
    <TableCell className={classes.tableHeader}>
      <Table>
        <TableRow>
          <TableCell colSpan={2} className={classes.tableHeader} width={'140px'}>
            {t('CollectGridHeader.工学値', '工学値')}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell className={classes.tableHeader}>{t('CollectGridHeader.上限値', '上限値')}</TableCell>
          <TableCell className={classes.tableHeader}>{t('CollectGridHeader.下限値', '下限値')}</TableCell>
        </TableRow>
      </Table>
    </TableCell>
  );
  const colMul = (
    <TableCell className={classes.tableHeader} width={40}>
      {t('CollectGridHeader.乗率', '乗率')}
    </TableCell>
  );

  return (
    <TableRow>
      {fixNo}
      {fix0}
      {fix1}
      {fix2}
      {fix6}
      {fix7}
      {fix4}
      {fix8}
      {fix5}
      {fix3}
      {colDig}
      {colEng}
      {colMul}
      <TableCell className={classes.tableHeader} width={40}>
        {t('CollectGridHeader.単位', '単位')}
      </TableCell>
      {/* <TableCell className={classes.tableHeader}>{t('CollectGridHeader.判定値設定','判定値設定')}</TableCell> */}
      {/* <TableCell className={classes.tableHeader}>
        {t('CollectGridHeader.温度', '温度')}
        <br />
        {t('CollectGridHeader.上限異常', '上限異常')}
      </TableCell>
      <TableCell className={classes.tableHeader}>
        {t('CollectGridHeader.温度', '温度')}
        <br />
        {t('CollectGridHeader.上上限異常', '上上限異常')}
      </TableCell> */}

      <TableCell className={classes.tableHeader}>
        {t('CollectGridHeader.アベレージング処理', 'アベレージング処理')}
      </TableCell>
      {/* <TableCell className={classes.tableHeader}>
        {t('CollectGridHeader.エンベロープ処理', 'エンベロープ処理')}
      </TableCell> */}
      <TableCell className={classes.tableHeader}>
        {t('CollectGridHeader.モータ起動状態', 'モータ起動状態')}
        <br />
        {t('CollectGridHeader.検出センサ指定', '検出センサ指定')}
      </TableCell>
      <TableCell className={classes.tableHeader}>
        {t('CollectGridHeader.回転周波数', '回転周波数')}
        <br />
        {t('CollectGridHeader.算出センサ', '算出センサ')}
      </TableCell>
      <TableCell className={classes.tableHeader}>MEMO</TableCell>
    </TableRow>
  );
};

export default CollectGridHeaderIoT;
